import React, { useContext } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Quickbar from "../layouts/Quickbar";
import AuthContext from "../../context/auth-context";
import Breadcrumb from "../sections/Curriercompany-edit/Breadcrumb";
import Content from "../sections/Curriercompany-edit/Content";

export const Curriercompanyedit = (props) => {
  const ctx = useContext(AuthContext);

  return (
    <div
      className={
        ctx.darkMode
          ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
          : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
      }
    >
      <Sidenavigation />
      <main className="body-content">
        <Topnavigation />
        <div className="ms-content-wrapper">
          <div className="row">
            <div className="col-md-12">
              <Breadcrumb/>
              <Content />
            </div>
          </div>
        </div>
      </main>
      <Quickbar />
    </div>
  );
};

export default Curriercompanyedit;
